import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Download, ShieldCheck, Sparkles } from 'lucide-react';

export default function DesignerCard({ designer }) {
  const score = designer.trust_score ?? 4.9;
  const avatarSrc = designer.avatar_url
    || `https://api.dicebear.com/7.x/avataaars/svg?seed=${designer.id}`;

  const stars = score > 0 ? Number(score).toFixed(1) : '4.9';

  return (
    <Link
      to={`/designer/${designer.display_name}`}
      style={{ textDecoration: 'none' }}
    >
      <div 
        className="glass-panel"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          padding: '18px 20px',
          backgroundColor: 'var(--bg-surface)',
          borderRadius: '16px',
          border: '1px solid var(--border-subtle)',
          transition: 'all 0.2s ease',
          cursor: 'pointer',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.borderColor = 'var(--primary-border)';
          e.currentTarget.style.boxShadow = 'var(--shadow-card)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.borderColor = 'var(--border-subtle)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        <div style={{ position: 'relative', width: '52px', height: '52px', flexShrink: 0 }}>
          <img
            src={avatarSrc}
            alt={designer.display_name}
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'cover',
              background: 'var(--bg-elevated)',
            }}
            onError={e => {
              e.target.src = `https://api.dicebear.com/7.x/initials/svg?seed=${designer.display_name}`;
            }}
          />
          {designer.ghana_card_verified === 1 && (
            <div style={{
              position: 'absolute',
              bottom: '-2px',
              right: '-2px',
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              background: 'var(--accent)',
              color: '#0A0A14',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '2px solid var(--bg-surface)'
            }}>
              <ShieldCheck size={11} />
            </div>
          )}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2px' }}>
            <div style={{ 
              fontWeight: 700, 
              color: 'var(--text-primary)', 
              fontSize: '14.5px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
              {designer.first_name && designer.last_name 
                ? `${designer.first_name} ${designer.last_name}`
                : designer.display_name}
            </div>
            <div style={{
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: '3px', 
              fontSize: '12px', 
              fontWeight: 700,
              color: 'var(--warning)',
            }}>
              <Star size={12} fill="currentColor" />
              <span>{stars}</span>
            </div>
          </div>

          <div style={{ 
            fontSize: '12px', 
            color: 'var(--text-secondary)', 
            marginBottom: '6px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {designer.specialization || 'Visual Brand Designer'}
          </div>

          <div style={{ display: 'flex', gap: '12px', fontSize: '11.5px', color: 'var(--text-tertiary)' }}>
            <span>{designer.template_count || 0} assets</span>
            <span>•</span>
            <span>{(designer.total_downloads || 0).toLocaleString()} downloads</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
